import { Dialog, DialogContent, DialogTitle } from "@capacit-com/lara-law-shared-ui";

interface SubTenantsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tenantNames: string[];
}

const SubTenantsDialog = ({
  open,
  onOpenChange,
  tenantNames,
}: SubTenantsDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={undefined}>
        <div className="flex flex-col gap-2">
          <DialogTitle>
            <div className="font-semibold text-sm">Delt med:</div>
          </DialogTitle>
          <div className="flex flex-col gap-2 max-h-64 overflow-y-auto">
            {tenantNames.map((name, index) => (
              <span key={index} className="text-sm">
                {name}
              </span>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SubTenantsDialog;
